/* eslint-disable quote-props */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { getTotem, setCidade, setAuthToken } from '../../api/apiFactory';
import {
  fetchLimparCookie, fetchNomeCidade, fetchSolicitanteOcorrencias, fetchSolicitanteSic,
  fetchSolicitanteZeladoria,
  fetchVerificarStatusCidade,
} from '../../api/endpoints';
import {
  definirCidade, desfazerCidade, fetchConfiguracoesCidade, selectCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { resetarModais, selectModal, abrirModalAjuda } from '../../app/slices/modalSlice';
import { desfazerSecretaria } from '../../app/slices/secretariasSlice';
import { ReactComponent as AnexoSvg } from '../../assets/icons/anexo.svg';
import { ReactComponent as ListaSvg } from '../../assets/icons/lista.svg';
import LikePng from '../../assets/icons/like.png';
import UnlikePng from '../../assets/icons/unlike.png';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import { AbaContainerAcompanhamento } from '../../components/Botao/BotaoEstilo';
import Carregar from '../../components/Carregar/Carregar';
import CardOcorrencia from '../../components/CardOcorrencia/CardOcorrencia';
import CardSic from '../../components/CardSic/CardSic';
import CardZeladoria from '../../components/CardZeladoria/CardZeladoria';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalImpressao from '../../components/ModalImpressao/ModalImpressao';
import ModalImpressaoSic from '../../components/ModalImpressao/ModalImpressaoSic';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import ModalInformacaoAcompanhamento from '../../components/ModalInformacaoAcompanhamento/ModalInformacaoAcompanhamento';
import VisualizadorArquivos from '../../components/VisualizadorArquivos/VisualizadorArquivos';
import {
  Alerta,
  AppBody, AppFragment, CampoForm, Centro, Container, Divisor, Interno, Linha,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import './IniciarAcompanhamento.css';
import ModalImpressaoZeladoria from '../../components/ModalImpressao/ModalImpressaoZeladoria';
import {
  ConteudoProtocoloAcompanhamento,
  GridAcompanhamentos, GridProtocolosAcompanhamentos, GridStatusAcompanhamentos, ProtocoloAcompanhamento,
  ProtocoloAcompanhamentoDataHora,
  ProtocoloAcompanhamentoTitulo,
} from './IniciarAcompanhamentoEstilo';
import MenuAcompanhamento from '../../components/MenuAcompanhamento/MenuAcompanhamento';

const defaultBusca = {
  BuscaOcorrencia: '',
  BuscaSic: '',
  BuscaZeladoria: '',
};

const defaulValues = {
  BuscaCidade: '',
  IdEstado: '',
  NomeEstado: '',
};

// Abaixo eu tenho um objeto, o qual contém outros objetos dentro. O nome dos sub-objetos pode ser com ou sem ''.
// Caso tenha acento ou espaço no nome, será obrigatório usar ''.
// para acessar um sub-objeto do objeto principal, posso utilizar duas formas: defaultOcorrenciasStatus['Aberto'] ou defaultOcorrenciasStatus.Aberto
// Estrutura: Objeto principal (defaultOcorrenciasStatus), que contém outros objetos dentro, e dentro de cada sub-objeto tenho as propriedades de titulo, cor e um array de protocolos.

const defaultOcorrenciasStatus = {
  Aberto: { titulo: 'Abertas', cor: '#EE796E', protocolos: [] },
  Agendado: { titulo: 'Agendadas', cor: '#479FEC', protocolos: [] },
  Cancelado: { titulo: 'Canceladas', cor: '#999999', protocolos: [] },
  'Concluído': { titulo: 'Concluídas', cor: '#2DCC70', protocolos: [] },
  'Em andamento': { titulo: 'Em andamento', cor: '#F1C50E', protocolos: [] },
  Pendente: { titulo: 'Pendentes', cor: '#F992F9', protocolos: [] },
};

const defaultSicStatus = {
  Pendentes: { titulo: 'Pendentes', cor: '#EE796E', protocolos: [] },
  Respondidos: { titulo: 'Respondidos', cor: '#2DCC70', protocolos: [] },
};

const defaultZeladoriasStatus = {
  Aberto: { titulo: 'Abertas', cor: '#EE796E', protocolos: [] },
  Agendado: { titulo: 'Agendadas', cor: '#479FEC', protocolos: [] },
  Cancelado: { titulo: 'Canceladas', cor: '#999999', protocolos: [] },
  'Concluído': { titulo: 'Concluídas', cor: '#2DCC70', protocolos: [] },
  'Em andamento': { titulo: 'Em andamento', cor: '#F1C50E', protocolos: [] },
  Pendente: { titulo: 'Pendentes', cor: '#F992F9', protocolos: [] },
};

const IniciarAcompanhamento = () => {
  const [values, setValues] = useState(defaultBusca);

  const [ouvidoriaAtivo, setOuvidoriaAtivo] = useState(true);
  const [sicAtivo, setSicAtivo] = useState(false);
  const [zeladoriaAtivo, setZeladoriaAtivo] = useState(false);

  const [statusSelecionado, setStatusSelecionado] = useState(null);
  const [protocoloSelecionado, setProtocoloSelecionado] = useState(null);

  const [listaOcorrenciasCompleta, setListaOcorrenciasCompleta] = useState(null);
  const [listaSicCompleta, setListaSicCompleta] = useState(null);
  const [listaZeladoriasCompleta, setListaZeladoriasCompleta] = useState(null);

  const [listaOcorrenciasOrganizadoPorStatus, setListaOcorrenciasOrganizadoPorStatus] = useState(null);
  const [listaSicOrganizadoPorStatus, setListaSicOrganizadoPorStatus] = useState(null);
  const [listaZeladoriasOrganizadoPorStatus, setListaZeladoriasOrganizadoPorStatus] = useState(null);

  // const [listaSecretarias, setListaSecretarias] = useState(null);
  // const [listaEstados, setListaEstados] = useState(null);
  // const [estadoSelecionado, setEstadoSelecionado] = useState(false);

  const [refresh, setRefresh] = useState(false);

  const dadosLogin = useSelector(selectLogin);
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);

  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();

  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const cookieSelecionado2 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeCrie')) : null;
  const cookieSelecionadoSeparado2 = cookieSelecionado2 ? cookieSelecionado2.split('=') : null;
  const cookieIdEcrie = cookieSelecionadoSeparado2
    ? cookieSelecionadoSeparado2[cookieSelecionadoSeparado2.length - 1]
    : null;

  const cookieSelecionado3 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeSipe')) : null;
  const cookieSelecionadoSeparado3 = cookieSelecionado3 ? cookieSelecionado3.split('=') : null;
  const cookieIdEsipe = cookieSelecionadoSeparado3
    ? cookieSelecionadoSeparado3[cookieSelecionadoSeparado3.length - 1]
    : null;

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (id) => {
    if (id) {
      fetchVerificarStatusCidade(id).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    } else {
      history.push('/');
    }
  };

  const escolherCidade2 = async (Id, IdeCrie, IdeSipe, Campo, Brasao) => {
    checaCidadeAtiva(Id);
    // setListaSecretarias(null);
    setCidade({
      Id, IdeCrie, IdeSipe, Campo,
    });
    // setEstadoSelecionado(false);
    setValues(defaulValues);
    dispatch(definirCidade({
      idCidade: Id,
      idCidadeEcrie: IdeCrie,
      idCidadeEsipe: IdeSipe,
      nomeCidade: Campo,
      brasaoCidade: Brasao,
    }));
    await fetchLimparCookie();
    await dispatch(fetchConfiguracoesCidade());
    // await fetchSecretarias().then(setListaSecretarias);
  };

  const alterarStatusAcompanhamento = (status) => {
    if (status !== statusSelecionado) {
      setStatusSelecionado(status);
      setProtocoloSelecionado(null);
    }
  };

  const alterarAbaMenu = (opcao) => {
    setOuvidoriaAtivo(false);
    setSicAtivo(false);
    setZeladoriaAtivo(false);

    if (opcao === 'ouvidoria') {
      setOuvidoriaAtivo(true);
    } else if (opcao === 'sic') {
      setSicAtivo(true);
    } else if (opcao === 'zeladoria') {
      setZeladoriaAtivo(true);
    }

    setStatusSelecionado(null);
    setProtocoloSelecionado(null);
  };

  const retornarStatusSic = (sic) => {
    if (!sic.Resposta || (sic.Recurso && !sic.RespostaRecurso) || (sic.recursoRetificacao && !sic.respostaRecursoRetificacao)) {
      return 'Pendentes';
    }

    if ((sic.Resposta && !sic.Recurso && !sic.recursoRetificacao) || (sic.RespostaRecurso && !sic.recursoRetificacao) || sic.RespostaRecursoRetificacao) {
      return 'Respondidos';
    }

    return null;
  };

  useEffect(() => {
    if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S'
      && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'S' || dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'S'))
      && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'N'
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'N' || dadosCidade.configuracoes.OcultarAnonimoSic === 'N'))
      && (dadosCidade && dadosCidade.configuracoes
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N'))) {
      setOuvidoriaAtivo(false);
      setSicAtivo(false);
      setZeladoriaAtivo(true);
    } else if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'N'
      && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N'))
      && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S'
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'S' || dadosCidade.configuracoes.OcultarAnonimoSic === 'S'))
      && (dadosCidade && dadosCidade.configuracoes
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N'))) {
      setOuvidoriaAtivo(false);
      setSicAtivo(true);
      setZeladoriaAtivo(false);
    }

    if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') {
      Promise.all([
        fetchSolicitanteOcorrencias(),
        fetchSolicitanteSic(),
        fetchSolicitanteZeladoria(),
      ]).then(([dadosOcorrencias, dadosSic, dadosZeladorias]) => {
        setListaOcorrenciasCompleta(dadosOcorrencias);
        setListaSicCompleta(dadosSic);
        setListaZeladoriasCompleta(dadosZeladorias);

        // Importante: é utilizado { ... } ao invés de apenas atribuir "defaultOcorrenciasStatus" diretamente, pois caso eu atribuisse diretamente,
        // "ouvidoriasOrganizadas" seria uma referência para o mesmo objeto "defaultOcorrenciasStatus". Com isso, qualquer mudança que eu fizesse em
        // "ouvidoriasOrganizadas", refleteria em "defaultOcorrenciasStatus" também. Dito isso, eu utilizo a maneira abaixo que faz uma CÓPIA SEPARADA
        // de defaultOcorrenciasStatus, e qualquer mudança que eu fizer não irá refletir no objeto copiado.
        // Quando eu estava utilizando a maneira que gera uma "referência" ao invés de uma "cópia", eu estava com um bug pois eu estava alterando o valor de
        // "defaultOcorrenciasStatus", e com isso, quando eu chamava o mesmo novamente para "atribuir" à "ouvidoriasOrganizadas", este vinha com o "defaultOcorrenciasStatus"
        // já populado com informações anteriores, ao invés de vir vazio sempre. Por isso então utilizo a metodologia que gera uma CÓPIA ao invés de gerar uma REFERENCIA.

        if (dadosOcorrencias && !dadosOcorrencias.Message) {
          const ocorrenciasOrganizadas = { ...defaultOcorrenciasStatus };

          Object.keys(ocorrenciasOrganizadas).forEach((status) => {
            ocorrenciasOrganizadas[status].protocolos = [];
          });

          dadosOcorrencias.forEach((ocorrencia) => {
            if (ocorrenciasOrganizadas[ocorrencia.Status]) {
              ocorrenciasOrganizadas[ocorrencia.Status].protocolos.push(ocorrencia);
            }
          });

          setListaOcorrenciasOrganizadoPorStatus(ocorrenciasOrganizadas);
        }

        if (dadosSic && !dadosSic.Message) {
          const sicOrganizados = { ...defaultSicStatus };

          Object.keys(sicOrganizados).forEach((status) => {
            sicOrganizados[status].protocolos = [];
          });

          dadosSic.forEach((sic) => {
            sicOrganizados[retornarStatusSic(sic)].protocolos.push(sic);
          });

          setListaSicOrganizadoPorStatus(sicOrganizados);
        }

        if (dadosZeladorias && !dadosZeladorias.Message) {
          const zeladoriasOrganizadas = { ...defaultZeladoriasStatus };

          Object.keys(zeladoriasOrganizadas).forEach((status) => {
            zeladoriasOrganizadas[status].protocolos = [];
          });

          dadosZeladorias.forEach((zeladoria) => {
            if (zeladoriasOrganizadas[zeladoria.Status]) {
              zeladoriasOrganizadas[zeladoria.Status].protocolos.push(zeladoria);
            }
          });

          setListaZeladoriasOrganizadoPorStatus(zeladoriasOrganizadas);
        }
      });
    }
  }, [dadosLogin, refresh]);

  useEffect(() => {
    // fetchCidades().then(setListaEstados);

    if (getTotem() === 'true') {
      // setTimeout(() => {
      //   document.querySelector('body').click();
      //   document.querySelector('body').focus();
      //   document.querySelector('body').click();
      // }, 2000);

      history.push('/totem');
    }

    if (search && search.includes('&id=')) {
      const idCidade = search.split('&id=')[1];
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      limpaLoginAnonimo(dadosLogin);
      fetchNomeCidade(idCidade).then((nomeCidade) => { escolherCidade2(idCidade, 0, 0, nomeCidade); });
    }

    if (cookieId) {
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      limpaLoginAnonimo(dadosLogin);
      fetchNomeCidade(cookieId).then((nomeCidade) => { escolherCidade2(cookieId, cookieIdEcrie, cookieIdEsipe, nomeCidade); });
    }
    // if (dadosCidade.data) {
    //   fetchSecretarias().then(setListaSecretarias);
    // }

    if (getTotem() !== 'true') checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);

    if (dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N' && !(dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo')) {
      history.push('/');
    }

    if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S'
      && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'S' || dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'S'))
      && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'N'
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'N' || dadosCidade.configuracoes.OcultarAnonimoSic === 'N'))
      && (dadosCidade && dadosCidade.configuracoes
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N'))) {
      setOuvidoriaAtivo(false);
      setSicAtivo(false);
      setZeladoriaAtivo(true);
    } else if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'N'
      && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N'))
      && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S'
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'S' || dadosCidade.configuracoes.OcultarAnonimoSic === 'S'))
      && (dadosCidade && dadosCidade.configuracoes
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N'))) {
      setOuvidoriaAtivo(false);
      setSicAtivo(true);
      setZeladoriaAtivo(false);
    }

    if ((dadosCidade && dadosCidade.configuracoes)
    && ((dadosCidade.configuracoes.OcultarAppSic === 'N')
     && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'N' && dadosCidade.configuracoes.OcultarAnonimoSic === 'N' && dadosLogin.data === null))
    && ((dadosCidade.configuracoes.OcultarAppZeladoria === 'N')
     && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'N' && dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N' && dadosLogin.data === null))
    && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'N' && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N')) {
      history.push('/');
    }
  }, []);

  // botão criar (exibido na tela quando não houver protocolo)
  const criarManifestacao = () => {
    dispatch(desfazerSecretaria());
    history.push('/ouvidoria');
  };

  const criarSic = () => {
    dispatch(desfazerSecretaria());
    history.push('/sic');
  };

  const criarZeladoria = () => {
    dispatch(desfazerSecretaria());
    history.push('/zeladoria');
  };

  // onRefresh
  const onRefreshOcorrencias = (id) => {
    setRefresh(!refresh);
    setProtocoloSelecionado(null);

    if (id) {
      fetchSolicitanteOcorrencias().then((dadosOcorrencias) => {
        if (!dadosOcorrencias.Message) {
          const ocorrenciaAtual = dadosOcorrencias.find((ocorrencia) => ocorrencia.Id === id.toString());

          if (ocorrenciaAtual) {
            setStatusSelecionado(ocorrenciaAtual.Status);
            setProtocoloSelecionado(ocorrenciaAtual);
          }
        }
      });
    }
  };

  const onRefreshSic = (id) => {
    setRefresh(!refresh);
    setProtocoloSelecionado(null);

    if (id) {
      fetchSolicitanteSic().then((dadosSic) => {
        if (!dadosSic.Message) {
          const sicAtual = dadosSic.find((sic) => sic.Id === id.toString());

          if (sicAtual) {
            setStatusSelecionado(retornarStatusSic(sicAtual));
            setProtocoloSelecionado(sicAtual);
          }
        }
      });
    }
  };

  const onRefreshZeladorias = (id) => {
    setRefresh(!refresh);
    setProtocoloSelecionado(null);

    if (id) {
      fetchSolicitanteZeladoria().then((dadosZeladorias) => {
        if (!dadosZeladorias.Message) {
          const zeladoriaAtual = dadosZeladorias.find((zeladoria) => zeladoria.Id === id.toString());

          if (zeladoriaAtual) {
            setStatusSelecionado(zeladoriaAtual.Status);
            setProtocoloSelecionado(zeladoriaAtual);
          }
        }
      });
    }
  };

  // Pesquisa de usuário logado (não anônimo)
  const pesquisarProtocolosManifestacao = (pesquisa) => {
    setValues({
      ...values,
      BuscaOcorrencia: pesquisa,
    });

    const filtro = listaOcorrenciasCompleta.filter(({ Id }) => Id.includes(pesquisa));

    if (filtro.length === 1) {
      setStatusSelecionado(filtro[0].Status);
      setProtocoloSelecionado(filtro[0]);
    } else {
      setStatusSelecionado(null);
      setProtocoloSelecionado(null);
    }

    const ouvidoriasOrganizadas = { ...defaultOcorrenciasStatus };

    Object.keys(ouvidoriasOrganizadas).forEach((status) => {
      ouvidoriasOrganizadas[status].protocolos = [];
    });

    filtro.forEach((ocorrencia) => {
      if (ouvidoriasOrganizadas[ocorrencia.Status]) {
        ouvidoriasOrganizadas[ocorrencia.Status].protocolos.push(ocorrencia);
      }
    });

    setListaOcorrenciasOrganizadoPorStatus(ouvidoriasOrganizadas);
  };

  const pesquisarProtocolosSic = (pesquisa) => {
    setValues({
      ...values,
      BuscaSic: pesquisa,
    });

    const filtro = listaSicCompleta.filter(({ Id }) => Id.includes(pesquisa));

    if (filtro.length === 1) {
      setStatusSelecionado(retornarStatusSic(filtro[0]));
      setProtocoloSelecionado(filtro[0]);
    } else {
      setStatusSelecionado(null);
      setProtocoloSelecionado(null);
    }

    const sicOrganizados = { ...defaultSicStatus };

    Object.keys(sicOrganizados).forEach((status) => {
      sicOrganizados[status].protocolos = [];
    });

    filtro.forEach((sic) => {
      sicOrganizados[retornarStatusSic(sic)].protocolos.push(sic);
    });

    setListaSicOrganizadoPorStatus(sicOrganizados);
  };

  const pesquisarProtocolosZeladoria = (pesquisa) => {
    setValues({
      ...values,
      BuscaZeladoria: pesquisa,
    });

    const filtro = listaZeladoriasCompleta.filter(({ Id }) => Id.includes(pesquisa));

    if (filtro.length === 1) {
      setStatusSelecionado(filtro[0].Status);
      setProtocoloSelecionado(filtro[0]);
    } else {
      setStatusSelecionado(null);
      setProtocoloSelecionado(null);
    }

    const zeladoriasOrganizadas = { ...defaultZeladoriasStatus };

    Object.keys(zeladoriasOrganizadas).forEach((status) => {
      zeladoriasOrganizadas[status].protocolos = [];
    });

    filtro.forEach((zeladoria) => {
      if (zeladoriasOrganizadas[zeladoria.Status]) {
        zeladoriasOrganizadas[zeladoria.Status].protocolos.push(zeladoria);
      }
    });

    setListaZeladoriasOrganizadoPorStatus(zeladoriasOrganizadas);
  };

  // Pesquisa de usuário anônimo
  const pesquisarProtocolosManifestacaoAnonimo = async (value) => {
    const response = await fetch(`https://eouve.com.br/API/${dadosCidade.data.idCidade}/solicitante/ouvidoriasanonima?idouvidoria=${value}`);
    const data = await response.json();

    if (data.Message) {
      setStatusSelecionado(null);
      setListaOcorrenciasOrganizadoPorStatus(null);
      setProtocoloSelecionado(data);
    } else {
      const ouvidoriasOrganizadas = { ...defaultOcorrenciasStatus };

      Object.keys(ouvidoriasOrganizadas).forEach((status) => {
        ouvidoriasOrganizadas[status].protocolos = [];
      });

      if (ouvidoriasOrganizadas[data[0].Status]) {
        ouvidoriasOrganizadas[data[0].Status].protocolos.push(data[0]);
      }

      setStatusSelecionado(data[0].Status);
      setListaOcorrenciasOrganizadoPorStatus(ouvidoriasOrganizadas);
      setProtocoloSelecionado(data[0]);
    }
  };

  const pesquisarProtocolosSicAnonimo = async (value) => {
    const response = await fetch(`https://eouve.com.br/api/${dadosCidade.data.idCidade}/solicitante/sicsanonima?idsic=${value}`);
    const data = await response.json();

    if (data.Message) {
      setStatusSelecionado(null);
      setListaSicOrganizadoPorStatus(null);
      setProtocoloSelecionado(data);
    } else {
      const sicOrganizados = { ...defaultSicStatus };

      Object.keys(sicOrganizados).forEach((status) => {
        sicOrganizados[status].protocolos = [];
      });

      sicOrganizados[retornarStatusSic(data[0])].protocolos.push(data[0]);

      setStatusSelecionado(retornarStatusSic(data[0]));
      setListaSicOrganizadoPorStatus(sicOrganizados);
      setProtocoloSelecionado(data[0]);
    }
  };

  const pesquisarProtocolosZeladoriaAnonimo = async (value) => {
    const response = await fetch(`https://eouve.com.br/API/${dadosCidade.data.idCidade}/solicitante/zeladoriasanonima?idouvidoria=${value}`);
    const data = await response.json();

    if (data.Message) {
      setStatusSelecionado(null);
      setListaZeladoriasOrganizadoPorStatus(null);
      setProtocoloSelecionado(data);
    } else {
      const zeladoriasOrganizadas = { ...defaultZeladoriasStatus };

      Object.keys(zeladoriasOrganizadas).forEach((status) => {
        zeladoriasOrganizadas[status].protocolos = [];
      });

      if (zeladoriasOrganizadas[data[0].Status]) {
        zeladoriasOrganizadas[data[0].Status].protocolos.push(data[0]);
      }

      setStatusSelecionado(data[0].Status);
      setListaZeladoriasOrganizadoPorStatus(zeladoriasOrganizadas);
      setProtocoloSelecionado(data[0]);
    }
  };

  // Usuário logado (não anônimo)
  if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') {
    if (!listaOcorrenciasCompleta || !listaSicCompleta || !listaZeladoriasCompleta) {
      return (
        <Carregar />
      );
    }

    if (listaZeladoriasCompleta.Error || listaZeladoriasCompleta.Error || listaZeladoriasCompleta.Error) {
      history.push('/');
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      return (
        <Carregar />
      );
    }

    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
        {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
        {dadosModal.modalImpressaoZeladoria === 'aberto' && (<ModalImpressaoZeladoria />)}
        {ouvidoriaAtivo && dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento />)}
        {sicAtivo && dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento sic />)}
        {zeladoriaAtivo && dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento zeladoria />)}

        <AppHeader />

        {((ouvidoriaAtivo && (listaOcorrenciasCompleta && !listaOcorrenciasCompleta.Message))
        || (sicAtivo && (listaSicCompleta && !listaSicCompleta.Message))
        || (zeladoriaAtivo && (listaZeladoriasCompleta && !listaZeladoriasCompleta.Message))) && (
          <>
            {(dadosLogin && dadosLogin.data && dadosLogin.data.anonimo !== 'naoanonimo') && (
              <Botao
                onClick={() => dispatch(abrirModalAjuda())}
                ajudaAcompanhamento
              />
            )}

            {ouvidoriaAtivo && (
              <Botao
                onClick={() => history.push('/ouvidoria')}
                adicionar
              />
            )}

            {sicAtivo && (
              <Botao
                onClick={() => history.push('/sic')}
                adicionar
              />
            )}

            {zeladoriaAtivo && (
              <Botao
                onClick={() => history.push('/zeladoria')}
                adicionar
              />
            )}
          </>
        )}

        <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque} className="controle-fundo">
          <Container totem={getTotem() === 'true'}>
            <MenuAcompanhamento
              listaOcorrenciasCompleta={listaOcorrenciasCompleta}
              listaSicCompleta={listaSicCompleta}
              listaZeladoriasCompleta={listaZeladoriasCompleta}
              ouvidoriaAtivo={ouvidoriaAtivo}
              sicAtivo={sicAtivo}
              zeladoriaAtivo={zeladoriaAtivo}
              onClick={alterarAbaMenu}
            />

            <Divisor size="extraGrande" className="ocultarMobile" />

            <Divisor size="pequeno" />

            {ouvidoriaAtivo && (
              listaOcorrenciasCompleta && listaOcorrenciasCompleta.Message
                ? (
                  <Centro>
                    <ListaSvg
                      style={{
                        height: 180, width: 180,
                      }}
                      fill="#dededd"
                    />

                    <Divisor size="medio" />
                    <Botao
                      label="Cadastrar uma nova manifestação"
                      onClick={criarManifestacao}
                    />
                  </Centro>
                )
                : (
                  <Interno>
                    <Divisor border size="pequeno" />

                    <Linha>
                      <span style={{ marginRight: espacamento.pequeno }}>
                        Protocolo:
                      </span>
                      <CampoForm
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={values.BuscaOcorrencia}
                        onChange={({ target }) => pesquisarProtocolosManifestacao(target.value)}
                      />
                    </Linha>

                    <Divisor border size="pequeno" />

                    <Divisor />

                    {listaOcorrenciasOrganizadoPorStatus && (
                      <GridStatusAcompanhamentos>
                        {Object.keys(listaOcorrenciasOrganizadoPorStatus).map((status) => (
                          <Botao
                            key={status}
                            statusAcompanhamento
                            label={`${listaOcorrenciasOrganizadoPorStatus[status].titulo} (${listaOcorrenciasOrganizadoPorStatus[status].protocolos.length})`}
                            corFundo={listaOcorrenciasOrganizadoPorStatus[status].cor}
                            ativo={status === statusSelecionado}
                            onClick={() => alterarStatusAcompanhamento(status)}
                          />
                        ))}
                      </GridStatusAcompanhamentos>
                    )}

                    {listaOcorrenciasOrganizadoPorStatus
                    && listaOcorrenciasOrganizadoPorStatus[statusSelecionado]
                    && listaOcorrenciasOrganizadoPorStatus[statusSelecionado].protocolos
                    && listaOcorrenciasOrganizadoPorStatus[statusSelecionado].protocolos.length > 0 ? (
                      <GridAcompanhamentos>
                        <GridProtocolosAcompanhamentos>
                          {listaOcorrenciasOrganizadoPorStatus[statusSelecionado].protocolos.map((ocorrencia) => (
                            <ProtocoloAcompanhamento key={ocorrencia.Id} onClick={() => setProtocoloSelecionado(ocorrencia)} ativo={protocoloSelecionado && (ocorrencia.Id === protocoloSelecionado.Id)}>
                              <ProtocoloAcompanhamentoTitulo>
                                {ocorrencia.LikeUnlike && ocorrencia.LikeUnlike === 'L' && (
                                  <img src={LikePng} alt="Gostei" />
                                )}

                                {ocorrencia.LikeUnlike && ocorrencia.LikeUnlike === 'U' && (
                                  <img src={UnlikePng} alt="Não gostei" />
                                )}

                                {(ocorrencia.Arquivos && ocorrencia.Arquivos.length > 0) && (
                                  <AnexoSvg
                                    height={17}
                                    width={17}
                                    fill="#777"
                                  />
                                )}

                                <div>
                                  <b>Protocolo:</b>
                                  {' '}
                                  {ocorrencia.Id}
                                </div>
                              </ProtocoloAcompanhamentoTitulo>

                              <ProtocoloAcompanhamentoDataHora>{ocorrencia.DataHora}</ProtocoloAcompanhamentoDataHora>
                            </ProtocoloAcompanhamento>
                          ))}
                        </GridProtocolosAcompanhamentos>

                        <ConteudoProtocoloAcompanhamento>
                          {protocoloSelecionado && (
                            <CardOcorrencia
                              key={protocoloSelecionado.Id}
                              arquivos={protocoloSelecionado.Arquivos}
                              id={protocoloSelecionado.Id}
                              secretaria={protocoloSelecionado.Secretaria}
                              dataHora={protocoloSelecionado.DataHora}
                              descricao={protocoloSelecionado.Descricao}
                              assunto={protocoloSelecionado.Assunto}
                              bairro={protocoloSelecionado.Bairro}
                              andamentos={protocoloSelecionado.Historicos}
                              unidade={protocoloSelecionado.Unidade}
                              status={protocoloSelecionado.Status}
                              likeUnlike={protocoloSelecionado.LikeUnlike}
                              onRefresh={onRefreshOcorrencias}
                              endereco={protocoloSelecionado.Endereco}
                              numero={protocoloSelecionado.Numero}
                              dataHoraCanceladoConcluido={protocoloSelecionado.DataHoraCanceladoConcluido}
                              // Bragança paulista deseja fixar no início a resposta final, antes de qualquer outro andamento.
                              fixarRespostaFinal={dadosCidade && dadosCidade.data && dadosCidade.data.idCidade === '1138'}
                            />
                          )}
                        </ConteudoProtocoloAcompanhamento>
                      </GridAcompanhamentos>
                      )
                      : (
                        statusSelecionado && (<Alerta>Não há manifestações cadastradas para a opção selecionada.</Alerta>)
                      )}
                  </Interno>
                )
            )}

            {sicAtivo && (
              listaSicCompleta && listaSicCompleta.Message
                ? (
                  <Centro>
                    <ListaSvg
                      style={{
                        height: 180, width: 180,
                      }}
                      fill="#dededd"
                    />
                    <Divisor size="medio" />
                    <Botao
                      label="Cadastrar um novo pedido de informação"
                      onClick={criarSic}
                    />
                  </Centro>
                )
                : (
                  <Interno>
                    <Divisor border size="pequeno" />

                    <Linha>
                      <span style={{ marginRight: espacamento.pequeno }}>
                        Protocolo:
                      </span>
                      <CampoForm
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={values.BuscaSic}
                        onChange={({ target }) => pesquisarProtocolosSic(target.value)}
                      />
                    </Linha>

                    <Divisor border size="pequeno" />

                    <Divisor />

                    {listaSicOrganizadoPorStatus && (
                      <GridStatusAcompanhamentos>
                        {Object.keys(listaSicOrganizadoPorStatus).map((status) => (
                          <Botao
                            key={status}
                            statusAcompanhamento
                            label={`${listaSicOrganizadoPorStatus[status].titulo} (${listaSicOrganizadoPorStatus[status].protocolos.length})`}
                            corFundo={listaSicOrganizadoPorStatus[status].cor}
                            ativo={status === statusSelecionado}
                            onClick={() => alterarStatusAcompanhamento(status)}
                          />
                        ))}
                      </GridStatusAcompanhamentos>
                    )}

                    {listaSicOrganizadoPorStatus
                    && listaSicOrganizadoPorStatus[statusSelecionado]
                    && listaSicOrganizadoPorStatus[statusSelecionado].protocolos
                    && listaSicOrganizadoPorStatus[statusSelecionado].protocolos.length > 0 ? (
                      <GridAcompanhamentos>
                        <GridProtocolosAcompanhamentos>
                          {listaSicOrganizadoPorStatus[statusSelecionado].protocolos.map((sic) => (
                            <ProtocoloAcompanhamento key={sic.Id} onClick={() => setProtocoloSelecionado(sic)} ativo={protocoloSelecionado && (sic.Id === protocoloSelecionado.Id)}>
                              <ProtocoloAcompanhamentoTitulo>
                                {(sic.Arquivos && sic.Arquivos.length > 0) && (
                                  <AnexoSvg
                                    height={17}
                                    width={17}
                                    fill="#777"
                                  />
                                )}

                                <div>
                                  <b>Protocolo:</b>
                                  {' '}
                                  {sic.Id}
                                </div>
                              </ProtocoloAcompanhamentoTitulo>

                              <ProtocoloAcompanhamentoDataHora>{sic.DataHora}</ProtocoloAcompanhamentoDataHora>
                            </ProtocoloAcompanhamento>
                          ))}
                        </GridProtocolosAcompanhamentos>

                        <ConteudoProtocoloAcompanhamento>
                          {protocoloSelecionado && (
                            <CardSic
                              key={protocoloSelecionado.Id}
                              id={protocoloSelecionado.Id}
                              assunto={protocoloSelecionado.Assunto}
                              unidade={protocoloSelecionado.Unidade}
                              dataHora={protocoloSelecionado.DataHora}
                              secretaria={protocoloSelecionado.Secretaria}
                              pergunta={protocoloSelecionado.Pergunta}
                              resposta={protocoloSelecionado.Resposta}
                              arquivos={protocoloSelecionado.Arquivos}
                              dataHoraResposta={protocoloSelecionado.DataHoraResposta}
                              recurso={protocoloSelecionado.Recurso}
                              respostaRecurso={protocoloSelecionado.RespostaRecurso}
                              dataHoraRespostaRecurso={protocoloSelecionado.DataHoraRespostaRecurso}
                              dataHoraAberturaRecurso={protocoloSelecionado.DataHoraAberturaRecurso}
                              onRefresh={onRefreshSic}
                              retificacao={protocoloSelecionado.Retificacao}
                              dataHoraRetificacao={protocoloSelecionado.DataHoraRetificacao}
                              visivelRetificacao={protocoloSelecionado.VisivelRetificacao}
                              recursoRetificacao={protocoloSelecionado.RecursoRetificacao}
                              dataHoraAberturaRecursoRetificacao={protocoloSelecionado.DataHoraAberturaRecursoRetificacao}
                              dataHoraRespostaRecursoRetificacao={protocoloSelecionado.DataHoraRespostaRecursoRetificacao}
                              respostaRecursoRetificacao={protocoloSelecionado.RespostaRecursoRetificacao}
                            />
                          )}
                        </ConteudoProtocoloAcompanhamento>
                      </GridAcompanhamentos>
                      )
                      : (
                        statusSelecionado && (<Alerta>Não há pedidos de informação cadastrados para a opção selecionada.</Alerta>)
                      )}
                  </Interno>
                )
            )}

            {zeladoriaAtivo && (
              listaZeladoriasCompleta && listaZeladoriasCompleta.Message
                ? (
                  <Centro>
                    <ListaSvg
                      style={{
                        height: 180, width: 180,
                      }}
                      fill="#dededd"
                    />

                    <Divisor size="medio" />
                    <Botao
                      label="Cadastrar uma nova manifestação"
                      onClick={criarZeladoria}
                    />
                  </Centro>
                )
                : (
                  <Interno>
                    <Divisor border size="pequeno" />

                    <Linha>
                      <span style={{ marginRight: espacamento.pequeno }}>
                        Protocolo:
                      </span>
                      <CampoForm
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={values.BuscaZeladoria}
                        onChange={({ target }) => pesquisarProtocolosZeladoria(target.value)}
                      />
                    </Linha>

                    <Divisor border size="pequeno" />

                    <Divisor />

                    {listaZeladoriasOrganizadoPorStatus && (
                    <GridStatusAcompanhamentos>
                      {Object.keys(listaZeladoriasOrganizadoPorStatus).map((status) => (
                        <Botao
                          key={status}
                          statusAcompanhamento
                          label={`${listaZeladoriasOrganizadoPorStatus[status].titulo} (${listaZeladoriasOrganizadoPorStatus[status].protocolos.length})`}
                          corFundo={listaZeladoriasOrganizadoPorStatus[status].cor}
                          ativo={status === statusSelecionado}
                          onClick={() => alterarStatusAcompanhamento(status)}
                        />
                      ))}
                    </GridStatusAcompanhamentos>
                    )}

                    {listaZeladoriasOrganizadoPorStatus
                  && listaZeladoriasOrganizadoPorStatus[statusSelecionado]
                  && listaZeladoriasOrganizadoPorStatus[statusSelecionado].protocolos
                  && listaZeladoriasOrganizadoPorStatus[statusSelecionado].protocolos.length > 0 ? (
                    <GridAcompanhamentos>
                      <GridProtocolosAcompanhamentos>
                        {listaZeladoriasOrganizadoPorStatus[statusSelecionado].protocolos.map((zeladoria) => (
                          <ProtocoloAcompanhamento key={zeladoria.Id} onClick={() => setProtocoloSelecionado(zeladoria)} ativo={protocoloSelecionado && (zeladoria.Id === protocoloSelecionado.Id)}>
                            <ProtocoloAcompanhamentoTitulo>
                              {zeladoria.LikeUnlike && zeladoria.LikeUnlike === 'L' && (
                                <img src={LikePng} alt="Gostei" />
                              )}

                              {zeladoria.LikeUnlike && zeladoria.LikeUnlike === 'U' && (
                                <img src={UnlikePng} alt="Não gostei" />
                              )}

                              {(zeladoria.Arquivos && zeladoria.Arquivos.length > 0) && (
                                <AnexoSvg
                                  height={17}
                                  width={17}
                                  fill="#777"
                                />
                              )}

                              <div>
                                <b>Protocolo:</b>
                                {' '}
                                {zeladoria.Id}
                              </div>
                            </ProtocoloAcompanhamentoTitulo>

                            <ProtocoloAcompanhamentoDataHora>{zeladoria.DataHora}</ProtocoloAcompanhamentoDataHora>
                          </ProtocoloAcompanhamento>
                        ))}
                      </GridProtocolosAcompanhamentos>

                      <ConteudoProtocoloAcompanhamento>
                        {protocoloSelecionado && (
                          <CardZeladoria
                            key={protocoloSelecionado.Id}
                            arquivos={protocoloSelecionado.Arquivos}
                            id={protocoloSelecionado.Id}
                            secretaria={protocoloSelecionado.Secretaria}
                            dataHora={protocoloSelecionado.DataHora}
                            descricao={protocoloSelecionado.Descricao}
                            assunto={protocoloSelecionado.Assunto}
                            bairro={protocoloSelecionado.Bairro}
                            andamentos={protocoloSelecionado.Historicos}
                            unidade={protocoloSelecionado.Unidade}
                            status={protocoloSelecionado.Status}
                            likeUnlike={protocoloSelecionado.LikeUnlike}
                            onRefresh={onRefreshZeladorias}
                            endereco={protocoloSelecionado.Endereco}
                            numero={protocoloSelecionado.Numero}
                            dataHoraCanceladoConcluido={protocoloSelecionado.DataHoraCanceladoConcluido}
                            // Bragança paulista deseja fixar no início a resposta final, antes de qualquer outro andamento.
                            fixarRespostaFinal={dadosCidade && dadosCidade.data && dadosCidade.data.idCidade === '1138'}
                          />
                        )}
                      </ConteudoProtocoloAcompanhamento>
                    </GridAcompanhamentos>
                      )
                      : (
                        statusSelecionado && (<Alerta>Não há zeladorias cadastradas para a opção selecionada.</Alerta>)
                      )}
                  </Interno>
                )
            )}
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  // Usuário anônimo
  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
      {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
      {dadosModal.modalImpressaoZeladoria === 'aberto' && (<ModalImpressaoZeladoria />)}
      {(ouvidoriaAtivo && dadosModal.modalAjuda === 'aberto') && (<ModalInformacaoAcompanhamento />)}
      {(sicAtivo && dadosModal.modalAjuda === 'aberto') && (<ModalInformacaoAcompanhamento sic />)}
      {(zeladoriaAtivo && dadosModal.modalAjuda === 'aberto') && (<ModalInformacaoAcompanhamento zeladoria />)}

      <AppHeader />

      {ouvidoriaAtivo && (
        <Botao
          onClick={() => history.push('/ouvidoria')}
          adicionar
        />
      )}

      {sicAtivo && (
        <Botao
          onClick={() => history.push('/sic')}
          adicionar
        />
      )}

      {zeladoriaAtivo && (
        <Botao
          onClick={() => history.push('/zeladoria')}
          adicionar
        />
      )}

      <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque} className="controle-fundo">
        <Container totem={getTotem() === 'true'}>
          <MenuAcompanhamento
            listaOcorrenciasCompleta={listaOcorrenciasCompleta}
            listaSicCompleta={listaSicCompleta}
            listaZeladoriasCompleta={listaZeladoriasCompleta}
            ouvidoriaAtivo={ouvidoriaAtivo}
            sicAtivo={sicAtivo}
            zeladoriaAtivo={zeladoriaAtivo}
            onClick={alterarAbaMenu}
          />

          <Divisor size="extraGrande" className="ocultarMobile" />

          <Divisor size="pequeno" />

          <Interno>
            <Divisor border size="pequeno" />

            <Linha style={{ flexWrap: 'wrap' }}>
              <span style={{ marginRight: espacamento.pequeno }}>
                Protocolo:
              </span>

              {ouvidoriaAtivo && (
                <>
                  <CampoForm
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    style={{ minWidth: '200' }}
                    value={values.BuscaOcorrencia}
                    onChange={({ target }) => setValues({
                      ...values,
                      BuscaOcorrencia: target.value,
                    })}
                  />
                  <Botao cep onClick={() => pesquisarProtocolosManifestacaoAnonimo(values.BuscaOcorrencia)} />
                </>
              )}

              {sicAtivo && (
                <>
                  <CampoForm
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    value={values.BuscaSic}
                    onChange={({ target }) => setValues({
                      ...values,
                      BuscaSic: target.value,
                    })}
                  />
                  <Botao cep onClick={() => pesquisarProtocolosSicAnonimo(values.BuscaSic)} />
                </>
              )}

              {zeladoriaAtivo && (
                <>
                  <CampoForm
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    style={{ minWidth: '200' }}
                    value={values.BuscaZeladoria}
                    onChange={({ target }) => setValues({
                      ...values,
                      BuscaZeladoria: target.value,
                    })}
                  />
                  <Botao cep onClick={() => pesquisarProtocolosZeladoriaAnonimo(values.BuscaZeladoria)} />
                </>
              )}
            </Linha>
          </Interno>

          <Divisor border size="pequeno" />

          {ouvidoriaAtivo && (
            <>
              <div style={{
                fontSize: 14, background: '#e9e9e9', border: '1px solid #b5b5b5', borderRadius: 5, padding: 14, color: '#6a6a6a',
              }}
              >
                Consulta disponível apenas para manifestações que foram solicitadas de forma anônima. Para manifestações identificadas é necessário realizar o login no aplicativo/site.
              </div>

              <Divisor size="medio" />

              {listaOcorrenciasOrganizadoPorStatus && (
                <GridStatusAcompanhamentos>
                  {Object.keys(listaOcorrenciasOrganizadoPorStatus).map((status) => (
                    <Botao
                      key={status}
                      statusAcompanhamento
                      label={`${listaOcorrenciasOrganizadoPorStatus[status].titulo} (${listaOcorrenciasOrganizadoPorStatus[status].protocolos.length})`}
                      corFundo={listaOcorrenciasOrganizadoPorStatus[status].cor}
                      ativo={status === statusSelecionado}
                      onClick={() => alterarStatusAcompanhamento(status)}
                    />
                  ))}
                </GridStatusAcompanhamentos>
              )}

              {listaOcorrenciasOrganizadoPorStatus
              && listaOcorrenciasOrganizadoPorStatus[statusSelecionado]
              && listaOcorrenciasOrganizadoPorStatus[statusSelecionado].protocolos
              && listaOcorrenciasOrganizadoPorStatus[statusSelecionado].protocolos.length > 0
                ? (
                  <GridAcompanhamentos>
                    <GridProtocolosAcompanhamentos>
                      {listaOcorrenciasOrganizadoPorStatus[statusSelecionado].protocolos.map((ocorrencia) => (
                        <ProtocoloAcompanhamento key={ocorrencia.Id} onClick={() => setProtocoloSelecionado(ocorrencia)} ativo={protocoloSelecionado && (ocorrencia.Id === protocoloSelecionado.Id)}>
                          <ProtocoloAcompanhamentoTitulo>
                            {ocorrencia.LikeUnlike && ocorrencia.LikeUnlike === 'L' && (
                              <img src={LikePng} alt="Gostei" />
                            )}

                            {ocorrencia.LikeUnlike && ocorrencia.LikeUnlike === 'U' && (
                              <img src={UnlikePng} alt="Não gostei" />
                            )}

                            {(ocorrencia.Arquivos && ocorrencia.Arquivos.length > 0) && (
                              <AnexoSvg
                                height={17}
                                width={17}
                                fill="#777"
                              />
                            )}

                            <div>
                              <b>Protocolo:</b>
                              {' '}
                              {ocorrencia.Id}
                            </div>
                          </ProtocoloAcompanhamentoTitulo>

                          <ProtocoloAcompanhamentoDataHora>{ocorrencia.DataHora}</ProtocoloAcompanhamentoDataHora>
                        </ProtocoloAcompanhamento>
                      ))}
                    </GridProtocolosAcompanhamentos>

                    <ConteudoProtocoloAcompanhamento>
                      {protocoloSelecionado && (
                        <CardOcorrencia
                          key={protocoloSelecionado.Id}
                          arquivos={protocoloSelecionado.Arquivos}
                          id={protocoloSelecionado.Id}
                          secretaria={protocoloSelecionado.Secretaria}
                          dataHora={protocoloSelecionado.DataHora}
                          descricao={protocoloSelecionado.Descricao}
                          assunto={protocoloSelecionado.Assunto}
                          bairro={protocoloSelecionado.Bairro}
                          andamentos={protocoloSelecionado.Historicos}
                          unidade={protocoloSelecionado.Unidade}
                          status={protocoloSelecionado.Status}
                          likeUnlike={protocoloSelecionado.LikeUnlike}
                          onRefresh={onRefreshOcorrencias}
                          endereco={protocoloSelecionado.Endereco}
                          numero={protocoloSelecionado.Numero}
                          dataHoraCanceladoConcluido={protocoloSelecionado.DataHoraCanceladoConcluido}
                          fixarRespostaFinal={dadosCidade && dadosCidade.data && dadosCidade.data.idCidade === '1138'}
                        />
                      )}
                    </ConteudoProtocoloAcompanhamento>
                  </GridAcompanhamentos>
                )
                : (
                  statusSelecionado && (<Alerta>Não há manifestações cadastradas para a opção selecionada.</Alerta>)
                )}
            </>
          )}

          {sicAtivo && (
            <>
              <div style={{
                fontSize: 14, background: '#e9e9e9', border: '1px solid #b5b5b5', borderRadius: 5, padding: 14, color: '#6a6a6a',
              }}
              >
                Consulta disponível apenas para pedidos de informações que foram solicitados de forma anônima. Para pedidos de informações identificados é necessário realizar o login no aplicativo/site.
              </div>

              <Divisor size="medio" />

              {listaSicOrganizadoPorStatus && (
                <GridStatusAcompanhamentos>
                  {Object.keys(listaSicOrganizadoPorStatus).map((status) => (
                    <Botao
                      key={status}
                      statusAcompanhamento
                      label={`${listaSicOrganizadoPorStatus[status].titulo} (${listaSicOrganizadoPorStatus[status].protocolos.length})`}
                      corFundo={listaSicOrganizadoPorStatus[status].cor}
                      ativo={status === statusSelecionado}
                      onClick={() => alterarStatusAcompanhamento(status)}
                    />
                  ))}
                </GridStatusAcompanhamentos>
              )}

              {listaSicOrganizadoPorStatus
              && listaSicOrganizadoPorStatus[statusSelecionado]
              && listaSicOrganizadoPorStatus[statusSelecionado].protocolos
              && listaSicOrganizadoPorStatus[statusSelecionado].protocolos.length > 0
                ? (
                  <GridAcompanhamentos>
                    <GridProtocolosAcompanhamentos>
                      {listaSicOrganizadoPorStatus[statusSelecionado].protocolos.map((sic) => (
                        <ProtocoloAcompanhamento key={sic.Id} onClick={() => setProtocoloSelecionado(sic)} ativo={protocoloSelecionado && (sic.Id === protocoloSelecionado.Id)}>
                          <ProtocoloAcompanhamentoTitulo>
                            {(sic.Arquivos && sic.Arquivos.length > 0) && (
                              <AnexoSvg
                                height={17}
                                width={17}
                                fill="#777"
                              />
                            )}

                            <div>
                              <b>Protocolo:</b>
                              {' '}
                              {sic.Id}
                            </div>
                          </ProtocoloAcompanhamentoTitulo>

                          <ProtocoloAcompanhamentoDataHora>{sic.DataHora}</ProtocoloAcompanhamentoDataHora>
                        </ProtocoloAcompanhamento>
                      ))}
                    </GridProtocolosAcompanhamentos>

                    <ConteudoProtocoloAcompanhamento>
                      {protocoloSelecionado && (
                        <CardSic
                          key={protocoloSelecionado.Id}
                          id={protocoloSelecionado.Id}
                          assunto={protocoloSelecionado.Assunto}
                          unidade={protocoloSelecionado.Unidade}
                          dataHora={protocoloSelecionado.DataHora}
                          secretaria={protocoloSelecionado.Secretaria}
                          pergunta={protocoloSelecionado.Pergunta}
                          resposta={protocoloSelecionado.Resposta}
                          arquivos={protocoloSelecionado.Arquivos}
                          dataHoraResposta={protocoloSelecionado.DataHoraResposta}
                          recurso={protocoloSelecionado.Recurso}
                          respostaRecurso={protocoloSelecionado.RespostaRecurso}
                          dataHoraRespostaRecurso={protocoloSelecionado.DataHoraRespostaRecurso}
                          dataHoraAberturaRecurso={protocoloSelecionado.DataHoraAberturaRecurso}
                          onRefresh={onRefreshSic}
                          retificacao={protocoloSelecionado.Retificacao}
                          dataHoraRetificacao={protocoloSelecionado.DataHoraRetificacao}
                          visivelRetificacao={protocoloSelecionado.VisivelRetificacao}
                          recursoRetificacao={protocoloSelecionado.RecursoRetificacao}
                          dataHoraAberturaRecursoRetificacao={protocoloSelecionado.DataHoraAberturaRecursoRetificacao}
                          dataHoraRespostaRecursoRetificacao={protocoloSelecionado.DataHoraRespostaRecursoRetificacao}
                          respostaRecursoRetificacao={protocoloSelecionado.RespostaRecursoRetificacao}
                        />
                      )}
                    </ConteudoProtocoloAcompanhamento>
                  </GridAcompanhamentos>
                )
                : (
                  statusSelecionado && (<Alerta>Não há pedidos de informação cadastrados para a opção selecionada.</Alerta>)
                )}
            </>
          )}

          {zeladoriaAtivo && (
            <>
              <div style={{
                fontSize: 14, background: '#e9e9e9', border: '1px solid #b5b5b5', borderRadius: 5, padding: 14, color: '#6a6a6a',
              }}
              >
                Consulta disponível apenas para manifestações que foram solicitadas de forma anônima. Para manifestações identificadas é necessário realizar o login no aplicativo/site.
              </div>

              <Divisor size="medio" />

              {listaZeladoriasOrganizadoPorStatus && (
                <GridStatusAcompanhamentos>
                  {Object.keys(listaZeladoriasOrganizadoPorStatus).map((status) => (
                    <Botao
                      key={status}
                      statusAcompanhamento
                      label={`${listaZeladoriasOrganizadoPorStatus[status].titulo} (${listaZeladoriasOrganizadoPorStatus[status].protocolos.length})`}
                      corFundo={listaZeladoriasOrganizadoPorStatus[status].cor}
                      ativo={status === statusSelecionado}
                      onClick={() => alterarStatusAcompanhamento(status)}
                    />
                  ))}
                </GridStatusAcompanhamentos>
              )}

              {listaZeladoriasOrganizadoPorStatus
              && listaZeladoriasOrganizadoPorStatus[statusSelecionado]
              && listaZeladoriasOrganizadoPorStatus[statusSelecionado].protocolos
              && listaZeladoriasOrganizadoPorStatus[statusSelecionado].protocolos.length > 0
                ? (
                  <GridAcompanhamentos>
                    <GridProtocolosAcompanhamentos>
                      {listaZeladoriasOrganizadoPorStatus[statusSelecionado].protocolos.map((zeladoria) => (
                        <ProtocoloAcompanhamento key={zeladoria.Id} onClick={() => setProtocoloSelecionado(zeladoria)} ativo={protocoloSelecionado && (zeladoria.Id === protocoloSelecionado.Id)}>
                          <ProtocoloAcompanhamentoTitulo>
                            {zeladoria.LikeUnlike && zeladoria.LikeUnlike === 'L' && (
                              <img src={LikePng} alt="Gostei" />
                            )}

                            {zeladoria.LikeUnlike && zeladoria.LikeUnlike === 'U' && (
                              <img src={UnlikePng} alt="Não gostei" />
                            )}

                            {(zeladoria.Arquivos && zeladoria.Arquivos.length > 0) && (
                              <AnexoSvg
                                height={17}
                                width={17}
                                fill="#777"
                              />
                            )}

                            <div>
                              <b>Protocolo:</b>
                              {' '}
                              {zeladoria.Id}
                            </div>
                          </ProtocoloAcompanhamentoTitulo>

                          <ProtocoloAcompanhamentoDataHora>{zeladoria.DataHora}</ProtocoloAcompanhamentoDataHora>
                        </ProtocoloAcompanhamento>
                      ))}
                    </GridProtocolosAcompanhamentos>

                    <ConteudoProtocoloAcompanhamento>
                      {protocoloSelecionado && (
                        <CardZeladoria
                          key={protocoloSelecionado.Id}
                          arquivos={protocoloSelecionado.Arquivos}
                          id={protocoloSelecionado.Id}
                          secretaria={protocoloSelecionado.Secretaria}
                          dataHora={protocoloSelecionado.DataHora}
                          descricao={protocoloSelecionado.Descricao}
                          assunto={protocoloSelecionado.Assunto}
                          bairro={protocoloSelecionado.Bairro}
                          andamentos={protocoloSelecionado.Historicos}
                          unidade={protocoloSelecionado.Unidade}
                          status={protocoloSelecionado.Status}
                          likeUnlike={protocoloSelecionado.LikeUnlike}
                          onRefresh={onRefreshZeladorias}
                          endereco={protocoloSelecionado.Endereco}
                          numero={protocoloSelecionado.Numero}
                          dataHoraCanceladoConcluido={protocoloSelecionado.DataHoraCanceladoConcluido}
                          fixarRespostaFinal={dadosCidade && dadosCidade.data && dadosCidade.data.idCidade === '1138'}
                        />
                      )}
                    </ConteudoProtocoloAcompanhamento>
                  </GridAcompanhamentos>
                )
                : (
                  statusSelecionado && (<Alerta>Não há zeladorias cadastradas para a opção selecionada.</Alerta>)
                )}
            </>
          )}

          {protocoloSelecionado && protocoloSelecionado.Message && (
            <Alerta>Nenhum resultado foi encontrado.</Alerta>
          )}
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarAcompanhamento;
